export const QueryString = {
  market: "mkt",
  languageCodeId: "lc",
  username: "username",
  webServicesFederationContext: "wctx",
  cobrandingContext: "cbcxt",
  command: "command",
  membername: "mn",
};
